export default __webpack_public_path__ + "static/media/arrow-input-white.2d6fb513.svg";